import { render, staticRenderFns } from "./reservasPorConfirmar.vue?vue&type=template&id=5b049177&scoped=true"
import script from "./reservasPorConfirmar.vue?vue&type=script&lang=js"
export * from "./reservasPorConfirmar.vue?vue&type=script&lang=js"
import style0 from "./reservasPorConfirmar.vue?vue&type=style&index=0&id=5b049177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b049177",
  null
  
)

export default component.exports